import { PieChart } from "./PieChart";
import { getClassement } from "./getClassement";

export const MatchsPieVic = ({ playerData, matchs }) => {
  const normalWin = matchs.data.filter(
    (item) =>
      item.victoire === "V" &&
      getClassement(item.classement) < playerData.ptsOff,
  ).length;
  const perfs = matchs.data.filter(
    (item) =>
      item.victoire === "V" &&
      getClassement(item.classement) > playerData.ptsOff,
  ).length;

  return (
    <>
      <h3>Défaites</h3>
      <div className="matchs-pie">
        <PieChart
          data={[
            { label: "Normales", value: normalWin, color: "#eb525c" },
            { label: "Perfs", value: perfs, color: "#377EB8" },
          ]}
        />
      </div>
    </>
  );
};
